import { defineComponent } from 'navigation-components/platform/models';
import { NOTIFICATIONS_TEASE_COMPONENT } from '../../constants';
import { Channels } from '../constants';
import { getPath, getQueryParams, isNotificationsDisable, onNewNotification, onPrimaryTabChange } from '../internal';
import { getTeaseStyle } from '../internal/getStyle';
const NAVIGATION_TEASE_IFRAME_ID = 'in-app-notifications-tease-iframe';
export const teaseNotificationsComponentDef = defineComponent(NOTIFICATIONS_TEASE_COMPONENT, () => {
  return {
    name: NOTIFICATIONS_TEASE_COMPONENT,
    path: getPath({
      channel: Channels.TEASE
    }),
    queryParams: getQueryParams(),
    iframeProps: {
      id: NAVIGATION_TEASE_IFRAME_ID,
      style: getTeaseStyle()
    },
    scrolling: false,
    functions: Object.assign({}, onNewNotification, onPrimaryTabChange),
    initiallyOpen: true,
    deferLoading: isNotificationsDisable(),
    capabilities: []
  };
});